import { Injectable } from '@angular/core';
import { DiagnoseCheckListBymappingId, DignoseSubCheckListDetailViewModel } from '../business-entities/diagnose-check-list-model';
import { GenericResponse } from '../business-entities/generic-response';
import { DiagnoseCheckListDataService } from '../data-services/diagnose-check-list-data.service';


@Injectable({
    providedIn: 'root'
})

export class DiagnoseCheckListBusinessService {
    Diagnosecheck:string
    IsAddDiagnoseItems:string
    diagnoseId:number=0;
    Id:number=0;

    constructor(private service: DiagnoseCheckListDataService) {
    }
    diagnoseCheckListbymappingIdList: DiagnoseCheckListBymappingId[];
    diagnoseCheckListbymappingId :any;
    diagnoseCheckList: DignoseSubCheckListDetailViewModel;
    async getDiagnoseCheckList(languageCode:string): Promise<DignoseSubCheckListDetailViewModel> {
        await this.service
            .getDiagnoseCheckList(languageCode)
            .then(
                (res: GenericResponse<DignoseSubCheckListDetailViewModel>) => {
                    this.diagnoseCheckList = res.responseObject;
                }
            );
        return this.diagnoseCheckList;
    }
    // deleteSpecialTool(id: number): Promise<any> {
    //     return this.service.deleteSpecialTool(id);
    // }

    async getDiagnoseCheckListBymappingId(MappingId: number) {
        await this.service
            .getDiagnoseCheckListBymappingId(MappingId)
            .then(
                (res: GenericResponse<any>) => {
                    this.diagnoseCheckListbymappingId = res;
                }
            );
        return this.diagnoseCheckListbymappingId;
    }

    addDiagnoseCheckList(model:any):Promise<any>{
        return this.service.addDiagnoseCheckList(model);
    }

    editDiagnoseCheckList(model:any):Promise<any>{
        return this.service.editDiagnoseCheckList(model);
    }
    GetServicesForDiagnoseChecklist(language:string,MappingId:number){
        return this.service.GetServicesForDiagnoseChecklist(language,MappingId);
    }
}